import { ExportableClass } from '@/types'
import { dateToUTC, utctoDate } from '@/classes/DateParser'

export enum WarningMessageType {
  Info = 'info'
}

export class WarningMessage extends ExportableClass {
  message = ''
  timestamp: {
    from: number,
    to: number
  } = { 
    from: (new Date()).getTime() / 1000,
    to: (new Date()).getTime() / 1000
  }
  title: string = ''
  type: WarningMessageType = WarningMessageType.Info

  constructor (data?: any) {
    super()
    if (typeof data === 'object') {
      if (data.message) {
        this.message = data.message
      }
      if (data.title) {
        this.title = data.title
      }
      if (data.type && WarningMessage[data.type]) {
        this.type = WarningMessage[data.type]
      }
      if (data?.timestamp?.from) {
        this.timestamp.from = data.timestamp.from
      }
      if (data?.timestamp?.to) {
        this.timestamp.to = data.timestamp.to
      }
    }
  }

  getFromDate (): Date {
    return utctoDate(this.timestamp.from * 1000)
  }

  setFromDate (date: Date) {
    this.timestamp.from = dateToUTC(date) / 1000
  }
  
  getToDate (): Date {
    return utctoDate(this.timestamp.to * 1000)
  }

  setToDate (date: Date) {
    this.timestamp.to = dateToUTC(date) / 1000
  }
}
